import isbot from 'isbot';

/**
 * User-agent used by Invicti, the web scanner we use at OpenDoor to scan for security concerns
 * We do not want to track events from Invicti in journey as they are not true UserEvents
 * ip: 54.88.149.100
 * X-Athena: user-agent used for tests which we don't actually want to track
 * We also block these user-agents in Cloudflare because we do not want to track them for pageViewEvents, which Cloudflare handles
 */
isbot.extend(['.*Netsparker', 'X-Athena']);

export const getIsBot = (userAgent: string) => isbot(userAgent);
